import { ofType } from 'redux-observable';
import { map, mergeMap,flatMap } from 'rxjs/operators';
import { from } from 'rxjs';
import { TransformResponse } from './transform';

import {
    SETSELECTED,
    SETPATIENTSELECTED,
    NO_CHANGE,
    SET as PATIENTSET,
    RESET as PATIENTRESET
} from 'one-state-subject/src/types';

import {
    setAction, resetAction
} from 'one-state-getproviderinfo-ath';

import {
    addAction
} from 'one-state-error/src/actions';
import {
    setAction as setAppointmentsTable,
} from 'one-state-appointments';

import {
    resetAction as SubjectSeletcedReset
} from 'one-state-subjectselected/src/actions';

import {
    resetAction as SourceSelectedReset
} from 'one-state-sourceselected/src/actions'

import {
    ErrorObject
} from 'one-state-error/src/errorobject';
import {format} from 'one-util-date';
import { Disposition } from 'one-model-local';
import { 
    addReferredProviderAthena, 
    addReferringProviderAthena, 
    setError as setReferralError,
} from 'one-state-pending-referrals';

import {
setError as setApptError,
addProviderAthena
} from 'one-state-appointments'

export const enum Types {
    STORE_DISPOSITION_CODE = 'store-disposition-code',
    REFERRED_PROVIDER_INFO_FETCH_ATHENA = 'referred-provider-info-fetch/athena',
    REFERRING_PROVIDER_INFO_FETCH_ATHENA = 'referring-provider-info-fetch/athena',
    ADD_PROVIDER_FETCH_ATHENA = 'provider-info-fetch/athena',
    SETSELECTED_ATHENA = 'one-state-subject/setselected-athena',
    SETAPPOINTMENTS = 'set-appointments/set-athena',
};

const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });
const setAppointments = (payload: any) => ({ type: Types.SETAPPOINTMENTS, payload });
const pushtoApptsTable = (payload: any) => setAppointmentsTable(payload);
/**
 * This Fuction will fetch the data of GetSession
 * from backend api and returns the response and calls
 * subsequent redux action
 * @param context contains the settings etc..
 */
export const fetchProviderInfoAthena = (context: any) => (
    (action$: any, state$: any) => {
        const errorTime = format(new Date(),'LT');
        const errorDate = format(new Date(),'LL');
        const { server, log, agentId,teamName, settings: {
            athenaendpoints: {
                getproviderinfo
            },
            compatible : { consolidated_api_invocation, contact_center_type },
        } } = context;
        return action$.pipe(
            consolidated_api_invocation 
                ? ofType(NO_CHANGE) 
                : ofType(Types.REFERRED_PROVIDER_INFO_FETCH_ATHENA, Types.REFERRING_PROVIDER_INFO_FETCH_ATHENA, Types.ADD_PROVIDER_FETCH_ATHENA),
           
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the patient Medical history response
                 */
                let dataresponse: any = action.payload;

                const callProviderInfoAPI = (datares: any) => {
                    if (datares) {
                        let headers = new Headers();
                        const responsefromAPI = server.get({
                            headers: headers,
                            path: getproviderinfo + "?ProviderID=" + (datares?.providerID)
                        })
                            .then((responsegetsession: any) => responsegetsession)
                            .catch((getproviderinfores: any) => {
                                log.error(
                                    "ccw-gadget,getproviderinfo-athena",
                                    "getproviderinfo-athena", {
                                        getproviderinfores
                                }
                                );
                                let errorbuild: ErrorObject={
                                    source:"GetSession",
                                    type:"error",
                                    status:getproviderinfores?.status,
                                    erroritems:getproviderinfores?.errors,
                                    error_date: errorDate,
                                    error_time: errorTime
                                };
                                return errorbuild;
                            })
                        log.debug(
                            "ccw-gadget,getsession-epic",
                            "getsession-epic response", {
                            responsefromAPI
                        });
                        return from(responsefromAPI)
                    } else {
                        return from([]);
                    }

                }
                //Calling callMedicalhistoryAPI function here
                //the reason is we need to use pipe function.
                return callProviderInfoAPI(dataresponse).
                    pipe(
                        map((responsereceived: any) => TransformResponse(responsereceived, context))).
                    pipe(
                        flatMap(responseAfterTransform => {
                            const actions: any =[];
                            if (responseAfterTransform.error) {
                                switch (action.type) {
                                    case Types.REFERRED_PROVIDER_INFO_FETCH_ATHENA:
                                    case Types.REFERRING_PROVIDER_INFO_FETCH_ATHENA:
                                        actions.push(setReferralError(responseAfterTransform.error));
                                        break;
                                    case Types.ADD_PROVIDER_FETCH_ATHENA:
                                        actions.push(setApptError(responseAfterTransform.error))
                                        break;
                                }
                                actions.push(addAction(responseAfterTransform.error));
                            } else {
                                let payload = {
                                    providerInfo: responseAfterTransform.providerInfo,
                                    referralAuthId: dataresponse.referralAuthId
                                };
                                switch (action.type) {
                                    case Types.REFERRED_PROVIDER_INFO_FETCH_ATHENA:
                                        actions.push(addReferredProviderAthena(payload));
                                        break;
                                    case Types.REFERRING_PROVIDER_INFO_FETCH_ATHENA:
                                        actions.push(addReferringProviderAthena(payload));
                                        break;
                                    case Types.ADD_PROVIDER_FETCH_ATHENA:
                                        let dataobj  = {
                                            apptid: dataresponse.apptID,
                                            providerInfo: responseAfterTransform.providerInfo
                                        }
                                        actions.push(addProviderAthena(dataobj));
                                        break;
                                }
                            }
                            return actions;
                        })
                    )
            })
        )
    }
);

/**
 * Listen for component clear and intiate state clear for GetSession
 * @param context  contains logger which is used for logging
 */
 export const clearSelectedSubSessionEpic = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget, selectedSub-epic",
            "clear-selectedSub-epic", {
        });
        return action$.pipe(
            ofType(PATIENTSET,SETSELECTED, PATIENTRESET, SETPATIENTSELECTED),
            map(action => SubjectSeletcedReset())
        )

    }
);

/**
 * Listen for component clear and intiate state clear for GetSession
 * @param context  contains logger which is used for logging
 */
 export const clearSelectedSourceSessionEpic = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget, selectedSource-epic",
            "clear-selectedSource-epic", {
        });
        return action$.pipe(
            ofType(PATIENTSET,SETSELECTED, PATIENTRESET, SETPATIENTSELECTED),
            map(action => SourceSelectedReset())
        )
    }
);